import { lazy } from "react"

const GraphIQLPage$$__react__lazy__component = lazy(() => 
    import("./GraphIqlPage__original__module.mjs")
        .then(module => module.get_$$GraphIqlPage$$GraphIQLPage$$react__component$$1iricxl81n89u())
        .then(component => ({ default: component }))
)

export const get_$$GraphIqlPage$$GraphIQLPage$$react__component$$1iricxl81n89u = () => GraphIQLPage$$__react__lazy__component